import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { CONSTANTS } from 'src/app/constants';

@Component({
  selector: 'app-best-selling',
  templateUrl: './best-selling.component.html',
  styleUrls: ['./best-selling.component.css']
})
export class BestSellingComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  @Output() errorEmitter = new EventEmitter();

  loading: boolean = false;

  dataItem: any = {
    chart: {
      aligncaptionwithcanvas: "0",
      plottooltext:
        "<b>$dataValue</b>",
      theme: "gammel",
      decimalSeparator: ",",
      thousandSeparator: ".",
      showvalues: "1",
      placevaluesinside: "0"
    },
    data: []
  };

  width = '100%';
  height = '300';
  type = 'bar2d';
  dataFormat = 'json';
  dataSource = this.dataItem;

  listItem: { label: string, type: number, value: number }[] = [];
  typeSelected: any = 2;
  dataApi = {
    branch: [],
    dataMin: "",
    dataMax: "",
    classification: 0
  }
  errorApi: boolean = false;
  message: string = "";
  topTooltip: string = 'No Totvs Moda para exibir informação nesse painel é necessário configurar o parâmetro corporativo LST_TPCLAS_PRD_TA';

  constructor(private api: ApiService) { }

  ngOnInit(): void {
  }

  filterItem(item: any) {
    if (item.branch != undefined) {
      this.dataApi.branch = item.branch;
      this.dataApi.dataMax = item.dataMax;
      this.dataApi.dataMin = item.dataMin;
      this.loading = true;
      let excelInfo: any[] = []
      this.selectProduct().subscribe(
        (data: any) => {
          data.dataRow.map((el: any, index: any) => {
            if (index === 0) {
              this.dataApi.classification = el.classification_type_code;
            }
            this.listItem.push(
              { label: el.classification_type_name, type: index, value: el.classification_type_code }
            )
          })
        },
        (error) => {
          this.loading = false;
          this.errorApi = true;
          this.message = CONSTANTS.MESSAGES.DATA_ERRO_BEST_SELLING;
          this.formatErrorMensagem(error.message);
        }
      );
      this.productReturn(item).subscribe(
        (data: any) => {
          data.dataRow.map((el: any) => {
            this.dataItem.data.push({
              label: el.classification_name,
              value: el.item_quantity
            })
            excelInfo.push({ 'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Classificação': this.listItem[0]?.label, 'Item': el.classification_name.toString(), 'Quantidade': el.item_quantity.toString(), 'Valor': 'R$' + el.invoice_value.toString() });
          })
          excelInfo.unshift({});
          localStorage.setItem('best-selling-sellers', JSON.stringify(excelInfo));
          this.loading = false;
          this.errorApi = false;
          this.recoverProduct(this.listItem[0]?.value ?? 0);
        },
        (error) => {
          this.loading = false;
          this.errorApi = true;
          this.message = CONSTANTS.MESSAGES.DATA_ERRO_BEST_SELLING;
          this.formatErrorMensagem(error.message);
        }
      );
    }
  }

  productReturn(item: any) {
    return this.api.postMoreSaleProductsSellerPanel(item.dataMin, item.dataMax, item.branch, item.classification);
  }

  selectProduct() {
    return this.api.getClassificationTypes()
  }

  recoverProduct(item: any) {
    this.loading = true;
    let excelInfo: any[] = [];
    let recoverSelectItem = '';
    this.listItem.map((el: any) => {
      if (el.value === item) {
        recoverSelectItem = el.label
      }
    });

    this.typeSelected = item;
    this.dataItem.data = [];
    this.dataApi.classification = item;
    this.productReturn(this.dataApi).subscribe(
      (data: any) => {
        data.dataRow.map((el: any) => {
          this.dataItem.data.push({
            label: el.classification_name,
            value: el.item_quantity
          })
          excelInfo.push({ 'Data Inicial': this.dataApi.dataMin, 'Data Final': this.dataApi.dataMax, 'Classificação': recoverSelectItem, 'Item': el.classification_name, 'Quantidade': el.item_quantity.toString(), 'Valor': 'R$' + el.invoice_value.toString() });
        })
        excelInfo.unshift({});
        localStorage.setItem('best-selling-sellers', JSON.stringify(excelInfo));
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_ERRO_BEST_SELLING;
        this.formatErrorMensagem(error.message);
      }
    );
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataBestSelling = [];
    let objectBestSelling = localStorage.getItem('best-selling-sellers');

    objectBestSelling != null
      ? (dataBestSelling = JSON.parse(objectBestSelling))
      : (dataBestSelling = []);
    const worksheetBestSelling = XLSX.utils.json_to_sheet(dataBestSelling);

    const workbook = {
      Sheets: {
        'best-selling': worksheetBestSelling,
      },
      SheetNames: [
        'best-selling',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-best-selling' + EXCEL_EXTENSION);
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: best-selling \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

}
